import {
	applyHistoricalFilter,
	openApHistoricalSection,
	openHomeHistoricalSection,
	openSiteHistoricalSection,
} from './adapter';

/**
 * Historical Client.
 *
 * Past client sessions, kept after the client disconnected. A separate
 * resource from the live list for the same reason Active and Historical
 * Alarms are separate: they are two tables with different columns, different
 * filters and different actions, sharing only an accordion and a tab.
 *
 * Two things make it unlike anything else here. It shows nothing at all
 * until a Site and a period are chosen - "Please set filter to see
 * historical clients" - so every request has to collect two values the user
 * did not mention. And its search box is wired to nothing, so this plugin
 * offers no lookup: filtering is the only thing that reaches the server.
 */
const historicalClientPlugin = {
	id: 'historical_client',
	version: 1,
	commandVersion: 1,
	resource: 'historical_client',
	// `reset` carries no command: Historical Clients shows nothing
	// without a Site and a period, so there is no cleared state to
	// reach and the capability explains that instead. Declared all the
	// same, the way auditLogs declares the create/edit/delete it only
	// explains - an operation nobody lists is indistinguishable from
	// one nobody noticed.
	operations: ['options', 'list', 'reset'],
	dependencies: {
		plugins: ['site', 'canvas.navigation'],
		resolvers: ['site'],
		destinations: ['home.dashboard', 'site.dashboard', 'ap.dashboard'],
	},
	sections: {
		'home.clients_historical': openHomeHistoricalSection,
		'site.clients_historical': openSiteHistoricalSection,
		'ap.clients_historical': openApHistoricalSection,
	},
	filters: {
		historical_client: applyHistoricalFilter,
	},
};

export default historicalClientPlugin;
